module.exports = __webpack_public_path__ + "img/top_tray_bluish.png?3711e66b0ac0e02a7b98da42a365d40e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/icons/top_tray_bluish.png
// module id = 258
// module chunks = 0